import angular from 'angular';
import uiRouter from 'angular-ui-router';
import brandsComponent from './brands.component';
import dataTable from 'angular-material-data-table';

let brandsModule = angular
  .module('brands', [uiRouter, dataTable])

  .config($stateProvider => {
    'ngInject';
    $stateProvider.state('brands', {
      url: '/brands',
      component: 'brands',
      parent: 'main',
      data: {
        permissions: {
          only: ['ADMIN'],
          redirectTo: 'home'
        }
      },
      resolve: {}
    });
  })
  .component('brands', brandsComponent).name;

export default brandsModule;
